import React from "react"
import { Theme, createStyles, IconButton, makeStyles } from "@material-ui/core";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

export interface TablePaginationActionsProps {
    count: number;
    onChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
    page: number;
    rowsPerPage: number;
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing(2.5),
    },
}));

const TablePaginationActions = (props: TablePaginationActionsProps) => {
    const { page, rowsPerPage, count } = props;
    const classes = useStyles();
    const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => props.onChangePage(event, 0);
    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => props.onChangePage(event, props.page - 1);
    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => props.onChangePage(event, props.page + 1);
    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => props.onChangePage(event, Math.max(0, Math.ceil(props.count / props.rowsPerPage) - 1));

    return (
        <div className={classes.root}>
            <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="First Page">
                <FirstPageIcon />
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="Previous Page">
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="Next Page">
                <KeyboardArrowRight />
            </IconButton>
            <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="Last Page">
                <LastPageIcon />
            </IconButton>
        </div>
    );
}

export default TablePaginationActions;